import GradientText from 'components/GradientText';
import { Button } from 'components/buttons/Button/Button';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import './styles.scss';
import { useSelector } from 'react-redux';
import { ROUTES } from 'constants/routes';

const AboutUs = () => {
    const { about_button, about_tag, about_text, about_title } =
        useSelector(state => state?.homepage?.data?.data) || {};

    return (
        <section className="container">
            <div className="inner-container type-2">
                <div className="main-text-container">
                    <LabelButton>{about_tag}</LabelButton>
                    <GradientText>
                        <span dangerouslySetInnerHTML={{ __html: about_title }} />
                    </GradientText>
                    <div className="offset-left-4">
                        <GradientText size="small">
                            <span dangerouslySetInnerHTML={{ __html: about_text }} />
                        </GradientText>
                        <Button href={ROUTES.aboutUs} type="learn-more-arrow" className="business-philosophy-button">
                            {about_button}
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;
